const RSVPErrorPage = ({ message }) => {
  return (
    <div className="container rsvp-error">
      <h2>Oops!</h2>
      <p>{message || "This invitation is no longer valid."}</p>
      <p>If you believe this is a mistake, please contact the event organizer.</p>
    </div>
  );
};

export default RSVPErrorPage;
